import { EVOLUTIVE_CARD, EVOLUTIVE_CROSS_CARD, MULTIPLE_CARD, SIMPLECROSS_CARD, SIMPLE_CARD } from 'src/sections/GroupCards/cardTypes';
import { analyzePrivClient } from '../api';

const exportTypes = {
  CSV: 'CSV',
  XLSX: 'XLSX',
};

const endpoints = {
  // Simples + GRADE
  [SIMPLE_CARD]: (surveyId, analyzeId, customerId, exportType) => `chart-export/pesquisas/${surveyId}/resultados/gerais/consolidados/clientes/${customerId}/perguntas/${analyzeId}/type/${exportType}`,
  [SIMPLECROSS_CARD]: (surveyId, analyzeId, customerId, exportType) => `chart-export/cruzamentos/simples/pesquisas/${surveyId}/clientes/${customerId}/perguntas/principais/${analyzeId}/types/${exportType}`,
  [MULTIPLE_CARD]: (_, analyzeId, customerId, exportType) => `chart-export/cruzamentos-multiplos/${analyzeId}/type/${exportType}`,
  [EVOLUTIVE_CARD]: (_, analyzeId, customerId, exportType) => `chart-export/resultados/evolutivos/${analyzeId}/types/${exportType}`,
};

class AnalyzeChartExportService {
  getCSV(cardType, surveyId, analyzeId, customerId, enunciado = 'relatorio') {
    const endpoint = endpoints[cardType](surveyId, analyzeId, customerId, exportTypes.CSV);

    if ([EVOLUTIVE_CARD].includes(cardType)) {
      const result = analyzePrivClient.post(endpoint, { enunciado });
      return result;
    }

    const result = analyzePrivClient.get(endpoint);
    return result;
  }

  getXLSX(cardType, surveyId, analyzeId, customerId, enunciado = 'relatorio') {
    const endpoint = endpoints[cardType](surveyId, analyzeId, customerId, exportTypes.XLSX);

    if ([EVOLUTIVE_CARD].includes(cardType)) {
      const result = analyzePrivClient.post(endpoint, { enunciado }, { responseType: "blob" });
      return result;
    }

    const result = analyzePrivClient.get(endpoint, { responseType: 'blob' });
    return result;
  }

  getCSVEvolutivoCruzamentos(idConfiguracao, idPerguntaCruzada, idAlternativaCruzada) {
    const endpoint = `chart-export/pesquisas/resultados/evolutivos/cruzamentos/configuracoes/${idConfiguracao}/perguntas/cruzadas/${idPerguntaCruzada}/alternativas/${idAlternativaCruzada}/types/CSV`;
    const result = analyzePrivClient.post(endpoint, { enunciado: 'relatorio' });
    return result;
  }

  getXLSXEvolutivoCruzamentos(idConfiguracao, idPerguntaCruzada, idAlternativaCruzada) {
    const endpoint = `chart-export/pesquisas/resultados/evolutivos/cruzamentos/configuracoes/${idConfiguracao}/perguntas/cruzadas/${idPerguntaCruzada}/alternativas/${idAlternativaCruzada}/types/XLSX`;

    const result = analyzePrivClient.post(endpoint, { enunciado: 'relatorio' }, { responseType: "blob" });
    return result;
  }

}

const analyzeChartExportService = new AnalyzeChartExportService();

export default analyzeChartExportService;
